<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="bg_wrap">
      <topPiece></topPiece>
      <div class="container" v-loading="loading">
        <titleConfig
          :title="langSet == 'cn' ? '个人资料' : 'Personal Information'"
          :type="2"
        ></titleConfig>
        <div class="personal_wrap flex flex_content_sb">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
            :label-position="isShowPC ? 'left' : 'top'"
            class="personal_form"
          >
            <el-form-item
              :label="langSet == 'cn' ? '姓名' : 'Name'"
              prop="nickname"
            >
              <el-input
                v-model="ruleForm.nickname"
                :placeholder="
                  langSet == 'cn' ? '请输入姓名' : 'Please enter name'
                "
              ></el-input>
            </el-form-item>
            <el-form-item :label="langSet == 'cn' ? '手机' : 'Phone Number'">
              <el-input
                v-model="mobile"
                :placeholder="
                  langSet == 'cn' ? '请输入手机' : 'Please enter phone number'
                "
                disabled
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="langSet == 'cn' ? '公司' : 'Company'"
              prop="company_name"
            >
              <el-input
                v-model="ruleForm.company_name"
                :placeholder="
                  langSet == 'cn' ? '请输入公司' : 'Please enter company'
                "
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="langSet == 'cn' ? '部门' : 'Department'"
              prop="industry"
            >
              <el-input
                v-model="ruleForm.industry"
                :placeholder="
                  langSet == 'cn' ? '请输入部门' : 'Please enter department'
                "
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="langSet == 'cn' ? '职务' : 'Position'"
              prop="position"
            >
              <el-input
                v-model="ruleForm.position"
                :placeholder="
                  langSet == 'cn' ? '请输入职务' : 'Please enter position'
                "
              ></el-input>
            </el-form-item>
            <el-form-item
              :label="langSet == 'cn' ? '电子邮件' : 'E-mail'"
              prop="email"
            >
              <el-input
                v-model="ruleForm.email"
                :placeholder="
                  langSet == 'cn' ? '请输入电子邮件' : 'Please enter email'
                "
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">{{
                langSet == "cn" ? "保存" : "save"
              }}</el-button>
            </el-form-item>
          </el-form>
          <div class="head_wrap">
            <img class="head_img" :src="avatar" alt="" />
            <div class="head_btn_wrap">
              <el-upload
                class="upload-demo"
                :action="$Url+'/pc/Upload/image'"
                :headers="headers"
                :show-file-list="false"
                :on-progress="handleProgress"
                :on-success="handleAvatarSuccess"
              >
                <div class="head_btn head_change">{{ langSet == "cn" ? '修改头像' : 'Update avatar'}}</div>
              </el-upload>
              <div class="head_btn" @click="handleDialog">
                {{ langSet == "cn" ? "认证展商" : "Exhibition Certification" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog width="400px" :visible.sync="dialogVisible" :show-close="false">
      <div class="dialog_wrap">
        <div class="dialog_title">
          {{ langSet == "cn" ? "展商认证" : "Exhibition Certification" }}
        </div>
        <el-form
          :model="companyForm"
          :rules="companyFormRules"
          ref="companyForm"
          label-width="80px"
          label-position="top"
          class="personal_form"
        >
          <el-form-item
            :label="langSet == 'cn' ? '账号' : 'Account number'"
            prop="username"
          >
            <el-input
              v-model="companyForm.username"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item
            :label="langSet == 'cn' ? '密码' : 'Password'"
            prop="password"
          >
            <el-input
              v-model="companyForm.password"
              type="password"
              placeholder="请输入"
            ></el-input>
            <div class="dialog_tips">
              {{
                langSet == "cn"
                  ? "请向您企业展会负责人所要验证信息"
                  : "Please request verifcation information from the person in charge of your company's exhibition"
              }}
            </div>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="submitCompanyForm('companyForm')"
              >{{ langSet == "cn" ? "提交" : "Submit" }}</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import topPiece from "@/components/topPiece.vue";
import { userInfo, updateInfo, companyAttestation } from "@/api/api";

export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn || '',
      meta: [
        {
          name: "description",
          content: this.metaData.description|| '',
        },
        {
          name: "keywords",
          content: this.metaData.keywords|| '',
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    topPiece,
    titleConfig,
  },
  data() {
    return {
      langSet: "",
      mobile: "",
      avatar: "",
      headers: {},
      ruleForm: {
        nickname: "",
        company_name: "",
        email: "",
        industry: "",
        position: "",
      },
      rules: {
        nickname: [{ required: true, message: "请输入姓名/please enter name", trigger: "blur" }],
        company_name: [
          { required: true, message: "请输入公司/please enter company", trigger: "blur" },
        ],
        position: [{ required: true, message: "请输入职务/please enter position", trigger: "blur" }],
      },
      companyForm: {
        username: "",
        password: "",
      },
      companyFormRules: {
        username: [{ required: true, message: "请输入账号/please enter account number", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码/please enter password", trigger: "blur" }],
      },
      dialogVisible: false,
      loading: false,
      isShowPC: true,
      metaData: {}
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = localStorage.getItem("languageSet") || "cn";
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    //25.6.16  判断是否移动端 dxm
    this.isMobile();
    //25.6.13 获取个人信息 dxm
    this.getUserInfo();
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      if (flag) {
        this.isShowPC = false;
      } else {
        this.isShowPC = true;
      }
    },
    async getUserInfo() {
      this.loading = true;
      const res = await userInfo();
      let {
        nickname,
        avatar_uri,
        mobile,
        company_name,
        position,
        industry,
        email,
      } = res.data;
      this.mobile = mobile;
      this.avatar = avatar_uri;
      this.ruleForm.nickname = nickname || "";
      this.ruleForm.company_name = company_name || "";
      this.ruleForm.position = position || "";
      this.ruleForm.industry = industry || "";
      this.ruleForm.email = email || "";
      this.loading = false;
    },
    handleDialog() {
      this.dialogVisible = !this.dialogVisible;
    },
    async submitForm(formName) {
      this.loading = true;
      try {
        const valid = await new Promise((resolve) => {
          this.$refs[formName].validate(resolve);
        });
        if (valid) {
          await updateInfo(this.ruleForm);
          this.$message.success("提交成功");
          //   setTimeout(() => {
          //     location.reload();
          //   }, 1000);
        } else {
          this.$message.error("保存失败，请检查输入信息");
          return false;
        }
        this.loading = false;
      } catch (err) {
        this.$message.error(`提交失败: ${err.message}`);
        console.error("submit error:", err);
        this.loading = false;
      }
    },
    async submitCompanyForm(formName) {
      this.loading = true;
      try {
        const valid = await new Promise((resolve) => {
          this.$refs[formName].validate(resolve);
        });
        if (valid) {
          await companyAttestation(this.companyForm);
          this.$message.success("认证成功");
          this.dialogVisible = false;
        } else {
          this.$message.error("认证失败，请检查输入信息");
          return false;
        }
        this.loading = false;
      } catch (err) {
        this.$message.error(`提交失败: ${err.message}`);
        this.loading = false;
      }
    },
    handleProgress() {
      this.loading = true;
    },
    async handleAvatarSuccess(res, file) {
      if (res.code == 1) {
        await updateInfo({ avatar: res.data.uri });
        this.avatar = res.data.uri;
      }
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.personal_wrap {
  height: 618px;
  margin: 40px 0 77px;
  padding: 40px 80px 64px 50px;
  box-sizing: border-box;
  background: #f7f8fa;
  .personal_form {
    width: 730px;
    /deep/ .el-form-item {
      margin-bottom: 25px;
    }
    /deep/ .el-input__inner {
      height: 52px;
      line-height: 52px;
      font-size: 16px;
      border-radius: 8px;
      border-color: #fff;
    }
    /deep/ .el-input.is-disabled .el-input__inner {
      border-color: #e4e7ed;
    }
    /deep/ .el-select {
      width: 100%;
    }
    /deep/ .el-button--primary {
      width: 168px;
      height: 52px;
      font-size: 18px;
      border-radius: 8px;
      background: #004190;
      border-color: #004190;
    }
  }
  .head_wrap {
    .head_img {
      width: 100px;
      height: 100px;
      margin-bottom: 15px;
      border-radius: 50%;
    }
    .head_btn {
      width: 100px;
      height: auto;
      color: #fff;
      padding: 7px 0;
      font-size: 14px;
      cursor: pointer;
      line-height: 20px;
      text-align: center;
      background: #e62344;
      border-radius: 8px;
      border: 1px solid #e62344;
      margin-bottom: 10px;
    }
    .head_change {
      color: #004190;
      background: #fff;
      border-color: #004190;
    }
  }
}
/deep/ .el-dialog {
  height: 387px;
  margin-top: 0;
  background: #004190;
  border-radius: 20px;
  .el-dialog__body {
    color: #fff;
    padding: 0 30px;
  }
  .dialog_title {
    font-size: 18px;
    line-height: 25px;
    font-weight: 500;
    text-align: center;
    margin-bottom: 20px;
  }
  .el-form-item__label {
    color: #fff;
    font-size: 16px;
    line-height: 22px;
  }
  .el-button--primary {
    width: 180px;
    font-size: 16px;
    background: #e62344;
    border-color: #e62344;
    border-radius: 5px;
    margin: 0 auto;
    display: block;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item__error {
    top: 10px;
    left: auto;
    right: 15px;
  }
  .dialog_tips {
    padding-top: 10px;
    line-height: 20px;
  }
}
/deep/ .el-dialog__wrapper {
  display: flex;
  align-items: center;
}
@media only screen and (max-width: 767px) {
  .personal_wrap {
    height: auto;
    flex-wrap: wrap;
    padding: 0;
    margin-top: 0.38rem;
    position: relative;
    background: transparent;
    /deep/ .el-form {
      width: 100%;
      padding: 0.38rem;
      margin-top: 3.6rem;
      box-sizing: border-box;
      background: #f7f8fa;
    }
    .personal_form {
      .el-form-item {
        margin-bottom: 0.29rem;
      }
      /deep/.el-form-item__label {
        line-height: 0.42rem;
        padding-bottom: 0.1rem;
      }
      .el-button--primary {
        margin: 0.48rem auto 0;
        display: block;
      }
    }
    .head_wrap {
      position: absolute;
      top: 0;
      left: 50%;
      width: 65%;
      transform: translateX(-50%);
      .head_img {
        margin: 0 auto 15px;
      }
      .head_btn_wrap {
        display: flex;
        justify-content: space-between;
      }
    }
  }
  /deep/ .el-dialog {
    width: 90% !important;
    height: auto;
    .el-form-item__label {
      margin-bottom: 0.19rem;
    }
  }
}
</style>